<div class="mat-typology fullscreen-dialog">
    <h1 mat-dialog-title>{{title}}</h1>

    <mat-selection-list [(ngModel)]="selectedItems" #selectionList>
        <mat-list-option *ngFor="let item of items" [value]="item.id">
            {{ item.name }}
        </mat-list-option>
    </mat-selection-list>

    <div *ngIf="items?.length === 0" class="flex justify-center items-center h-32 bg-gray-100 rounded-md border border-dashed border-gray-300">
        <div class="text-center">
          <p class="text-gray-600 font-medium">{{noDataMessage}}</p>
        </div>
      </div>


</div>

<mat-divider></mat-divider>
<mat-dialog-actions class="dialog-footer">
    <button *ngIf="items?.length > 0" [mat-dialog-close]="selectedItems" mat-raised-button color="primary">
        Save
    </button>

    <button mat-dialog-close mat-raised-button>
        Cancel
    </button>
</mat-dialog-actions>
